import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobsRetryPost = {
    path: "/jobs/retry",
    method: RouteHttpVerb.POST
};
export { locationRestJobsRetryPost };
